import moment from 'moment';

export class DateTimeUtilities {
    /**
     * Sets the date time portion of a moment object to the date time given in a HTML5 formatted date time string
     *
     * @param target
     * @param dateTime
     */
    public static setDateTimeHtml5(target: moment.Moment, dateTime: string): moment.Moment {
        return DateTimeUtilities.setDateTimeMoment(target, moment(dateTime, moment.HTML5_FMT.DATETIME_LOCAL));
    }

    /**
     * Sets the date time portion of a moment object based on a source moment object
     *
     * @param target
     * @param dateTime
     */
    public static setDateTimeMoment(target: moment.Moment, dateTime: moment.Moment): moment.Moment {
        const dateTimeObject = dateTime.toObject();
        if (!target.isValid()) {
            target = moment();
        }

        target.set({
            years: dateTimeObject.years,
            months: dateTimeObject.months,
            date: dateTimeObject.date,
            hours: dateTimeObject.hours,
            minutes: dateTimeObject.minutes,
            seconds: dateTimeObject.seconds,
            milliseconds: dateTimeObject.milliseconds,
        });
        return target;
    }
}
